import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Style } from 'radium';
import classnames from 'classnames';
import Icon from '../../helper/Icon';

const styles = {
  classBased: {
    '.control-wrapper': {
      display: 'inline-block',
      border: '0.5px solid rgba(49, 53, 55, .2)',
      padding: '5px',
      borderRadius: '36px',
      background: 'rgba(255,255,255,0.8)'
    },
    '.icon-wrapper': {
      display: 'inline-block',
      textAlign: 'center',
      width: '35px',
      opacity: '0.7'
    },
    '.icon-wrapper:last-child': {
      borderRight: '0'
    },
    '.icon-wrapper:hover': {
      cursor: 'pointer',
      opacity: '1'
    }
  }
};

class MoveList extends Component {
  clickedUp = (event) => {
    const { position } = this.props;
    this.props.onPressUp(event, position);
  };

  clickedDown = (event) => {
    const { position } = this.props;
    this.props.onPressDown(event, position);
  };

  clickedDelete = (event) => {
    const { position } = this.props;
    this.props.onPressDelete(event, position);
  };

  clickedEdit = (event) => {
    const { position } = this.props;
    this.props.onPressEdit(event, position);
  };

  render() {
    const {
      position,
      listLength,
      disabledUp,
      disabledDown,
      disabledDelete,
      disabledEdit
    } = this.props;
    const isDisabledUp = disabledUp || position === 0;
    const isDisabledDown = disabledDown || position === listLength - 1;
    const iconSize = '14px';
    const iconWrapper = classnames('icon-wrapper', 'theme--fill-primary');
    return (
      <div>
        <div className="control-wrapper">
          {!isDisabledUp && (
            <div
              role="presentation"
              onClick={this.clickedUp}
              className={iconWrapper}
              title="Move up"
            >
              <Icon
                icon="arrow-up"
                size={iconSize}
                className="theme--fill-primary"
                viewBox="0 0 13 18"
              />
            </div>
          )}
          {!isDisabledDown && (
            <div
              role="presentation"
              onClick={this.clickedDown}
              className={iconWrapper}
              title="Move down"
            >
              <Icon
                icon="arrow-down"
                size={iconSize}
                className="theme--fill-primary"
                viewBox="0 0 13 19"
              />
            </div>
          )}
          {!disabledDelete && (
            <div
              role="presentation"
              onClick={this.clickedDelete}
              className={iconWrapper}
              title="Delete"
            >
              <Icon
                icon="line-delete"
                size={iconSize}
                className="theme--fill-primary"
                viewBox="0 0 17 17"
              />
            </div>
          )}
          {!disabledEdit && (
            <div
              role="presentation"
              onClick={this.clickedEdit}
              className={iconWrapper}
              title="Edit"
            >
              <Icon
                icon="line-edit"
                size={iconSize}
                className="theme--fill-primary"
                viewBox="0 0 14 14"
              />
            </div>
          )}
        </div>
        <Style rules={styles.classBased} />
      </div>
    );
  }
}

MoveList.propTypes = {
  position: PropTypes.number.isRequired,
  listLength: PropTypes.number.isRequired,
  onPressUp: PropTypes.func,
  onPressDown: PropTypes.func,
  onPressDelete: PropTypes.func,
  disabledDelete: PropTypes.bool,
  disabledUp: PropTypes.bool,
  disabledDown: PropTypes.bool,
  disabledEdit: PropTypes.bool,
  onPressEdit: PropTypes.func
};

MoveList.defaultProps = {
  onPressUp: () => {},
  onPressEdit: () => {},
  onPressDown: () => {},
  onPressDelete: () => {},
  disabledDelete: false,
  disabledUp: false,
  disabledDown: false,
  disabledEdit: true
};

export default MoveList;
